import f from "./index953.js";
function o(e, t) {
  var r = f(e.buffer);
  return new e.constructor(r, e.byteOffset, e.byteLength);
}
export {
  o as default
};
